<template>
  <div class="postOffice">
    <!-- 服務地點 -->
    <section class="container g-py-100">
      <div class="text-center g-mb-50">
        <h2 class="h1 g-color-black g-font-weight-600">智郵易投遞網點</h2>
        <!--<p class="lead">已加盟店鋪</p>-->
        <post-offices-list />
      </div>

    </section>
  </div>
</template>

<script>
import PostOfficesList from '../components/PostOfficesList';


export default {
  name: 'postOffice',
  components: {
    PostOfficesList,
  },
};
</script>

<style lang="scss">
  .home {
    .banner {
      // Small devices (landscape phones, 576px and up)
      @media (min-width: 576px) {
        .el-carousel__container {
          height: 230px;
        }
      }

      // Medium devices (tablets, 768px and up)
      @media (min-width: 768px) {
        .el-carousel__container {
          height: 430px;
        }
      }

      // Large devices (desktops, 992px and up)
      @media (min-width: 992px) {
        .el-carousel__container {
          height: 560px;
        }
      }

      // Extra large devices (large desktops, 1200px and up)
      @media (min-width: 1200px) {
        .el-carousel__container {
          height: 1080px;
        }
      }
    }

    .features-card {
      padding-top: 15.28571rem !important;
      &:nth-child(1) {
        background-image: url(../assets/img/ESS-mobile.jpg);
      }
      &:nth-child(2) {
        background-image: url(../assets/img/ESS-tracking.jpg);
      }
      &:nth-child(3) {
        background-image: url(../assets/img/ESS-plane.jpg);
      }
      &:nth-child(4) {
        background-image: url(../assets/img/ESS-export.jpg);
      }
      a {
        text-decoration: none;
      }
    }
  }
</style>
